import { render, staticRenderFns } from "./AddStudentData.vue?vue&type=template&id=41db5f66&scoped=true&"
import script from "./AddStudentData.vue?vue&type=script&lang=js&"
export * from "./AddStudentData.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentData.vue?vue&type=style&index=0&id=41db5f66&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41db5f66",
  null
  
)

export default component.exports